import React, { forwardRef } from 'react';
import { css, useTheme } from '@emotion/react';

import { rem } from '../../utilities/style';
import { colors } from '../../theme/colors';
import { fontWeights } from '../../theme/type';

const dropdownLinkStyles = (darkMode, button, arrowLink) => css`
  background: none;
  border: none;
  color: ${colors.gray['600']};
  font-size: ${rem(16)};
  line-height: 1.2;
  padding: 0;
  cursor: pointer;

  ${darkMode && `
    color: ${colors.gray['400']};
  `}

  &:focus-within,
  &:hover {
    text-decoration: underline;
    color: ${!darkMode ? colors.blue['800'] : colors.gray['200']};
  }

  ${button && `
    display: flex;
    padding: ${rem(12)} ${rem(16)};
    margin: 0 ${rem(-16)} ${rem(-16)};
    border-radius: ${rem(20)};
    background: ${colors.blue['500']};
    font-weight: ${fontWeights.medium};
    color: ${colors.white};

    &:focus-within,
    &:hover {
      background: ${colors.blue['800']};
      color: ${colors.white};
      text-decoration: none;
  `}

  ${arrowLink && `
    display: flex;
    align-items: flex-start;
    gap: ${rem(12)};
    font-weight: ${fontWeights.medium};
    color: ${colors.blue['800']};

    &::after {
      content: '';
      margin-top: ${rem(6)};
      border: ${rem(4)} solid transparent;
      border-right-width: 0;
      border-left-color: ${colors.blue['500']};
    }
  `}
`;

const DropdownLink = forwardRef(({
  component: Component,
  className,
  ...rest
}, ref) => {
  const darkMode = useTheme().pageOverrides?.includes('Dark Mode');
  return (
    <Component
      className={className}
      css={dropdownLinkStyles(
        darkMode,
        rest.button,
        rest.arrowLink
      )}
      ref={ref}
      {...rest} // eslint-disable-line react/jsx-props-no-spreading
    />
  );
});

export default DropdownLink;
